import { render, staticRenderFns } from "./PendingOrderlist.vue?vue&type=template&id=3a05e110&scoped=true"
import script from "./PendingOrderlist.vue?vue&type=script&lang=js"
export * from "./PendingOrderlist.vue?vue&type=script&lang=js"
import style0 from "./PendingOrderlist.vue?vue&type=style&index=0&id=3a05e110&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a05e110",
  null
  
)

export default component.exports